"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockIsControlledByContentItem = (block) => {
    return !!((block.contentItem ||
        block.contentFieldKey ||
        block.contentSlotNumber ||
        block.contentFeed) &&
        (block.contentItem &&
            block.contentFieldKey &&
            block.contentItem[block.contentFieldKey]));
};
//# sourceMappingURL=blockIsControlledByContentItem.js.map